__turbopack_context__.v({
  "mobile-width": "StatusToastNotification-module-scss-module__qQx4Ga__mobile-width",
});
